<template>
  <v-row dense>
    <v-col>
      <v-select
        v-model.number="PatologiaBeneficiario.id_patologia"
        :items="Lista"
        item-text="descripcion_patologia"
        item-value="id_patologia"
        label="Patologia"
        :return-object="false"
        hide-selected
        hide-details
        outlined
        dense
        @change="actualizar"
      ></v-select>
    </v-col>
    <v-col>
      <v-text-field
        dense
        outlined
        v-model="PatologiaBeneficiario.fechadesde"
        label="Fecha Desde"
        hide-details
        clearable
        type="date"
        @change="actualizar"
      ></v-text-field>
    </v-col>
    <v-col>
      <v-text-field
        dense
        outlined
        v-model="PatologiaBeneficiario.fechahasta"
        label="Fecha Hasta"
        hide-details
        clearable
        type="date"
        @change="actualizar"
      ></v-text-field>
    </v-col>
    <v-col v-if="PatologiaBeneficiario.id == 0">
      <v-btn small icon @click="guardar" color="green">
        <v-icon>
          mdi-check-bold
        </v-icon>
      </v-btn>
    </v-col>
    <v-col v-if="PatologiaBeneficiario.id != 0">
      <v-btn icon @click="eliminar(PatologiaBeneficiario.id)" color="red">
        <v-icon>
          mdi-delete
        </v-icon>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapState } from "vuex";
import API from "@/lib/API";
export default {
  props: {
    PatologiaBeneficiario: Object,
  },
  computed: {
    ...mapState("patologias", ["Lista"]),
  },
  methods: {
    actualizar() {
      if (this.PatologiaBeneficiario.id != 0) {
        this.guardar();
      }
    },
    async guardar() {
      let fechasta = '3000-01-01'
      if (this.PatologiaBeneficiario.fechahasta){
        fechasta = this.PatologiaBeneficiario.fechahasta;
      }
      if (
        this.PatologiaBeneficiario.id_patologia &&
        this.PatologiaBeneficiario.fechadesde &&
        this.PatologiaBeneficiario.fechadesde < fechasta
      ) {
        if (this.PatologiaBeneficiario.id == 0) {
          let pat = await API.PatologiasBeneficiarios.alta(
            this.PatologiaBeneficiario
          );
          this.$emit("alta", pat);
        } else {
          await API.PatologiasBeneficiarios.modificar(
            this.PatologiaBeneficiario
          );
        }
      }
    },
    eliminar(id) {
      API.PatologiasBeneficiarios.eliminar(id);
      this.$emit("baja", id);
    },
  },
};
</script>

<style></style>
